import { posthog } from './posthog';

type IdentifyUserParams = {
  userId: string | number;
  email?: string;
  role?: string;
  clientId?: string | number;
  clientName?: string;
  entitlements?: string[];
  isInternal?: boolean;
};

export function identifyPosthogUser({
  userId,
  email,
  role,
  clientId,
  clientName,
  entitlements,
  isInternal,
}: IdentifyUserParams) {
  posthog.identify(String(userId), {
    email,
    role,
    client_id: clientId,
    company_name: clientName,
    subscription: entitlements ?? [],
    is_internal: isInternal,
  });

  const groupKey = clientName || (clientId ? String(clientId) : undefined);

  if (groupKey) {
    posthog.group('company', groupKey, {
      name: clientName ?? groupKey,
      client_id: clientId,
      entitlements: entitlements ?? [],
    });
  }
}
